import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys, type CompaniesListFilters } from '@/core/data-fetching/queryKeys';
import { companiesService } from '../api/companies.service';

export function useCompaniesListQuery(filters: CompaniesListFilters) {
  return useQuery({
    queryKey: queryKeys.companies.list(filters),
    queryFn: () => companiesService.list(filters),
    placeholderData: keepPreviousData,
  });
}
